import React from 'react';
import SponsorPart from './components/SponsorPart';
import './Sponsors.scss';

const organizersImgs = [
  {
    src: 'imgs/logos/accenture.png',
    alt: 'Accenture',
    imgWidthLarge: '300px',
    imgWidthDesktop: '300px',
    imgWidthTablet: '300px',
    imgWidthMobile: '300px',
    classes: 'is-6-desktop is-full-mobile',
    url: 'https://careers.accenture.com/sk-sk/Pages/index.aspx'
  },
  {
    src: 'imgs/logos/STU-FEI-zfv.png',
    alt: 'STU FEI',
    imgWidthLarge: '300px',
    imgWidthDesktop: '300px',
    imgWidthTablet: '300px',
    imgWidthMobile: '300px',
    classes: 'is-6-desktop is-full-mobile',
    url: 'https://www.fei.stuba.sk/'
  }
];

const mediaPartnersImgs = [
  // {
  //   src: 'imgs/logos/robimeit.png',
  //   alt: 'RobimeIT',
  //   imgWidthLarge: '200px',
  //   imgWidthDesktop: '200px',
  //   imgWidthTablet: '200px',
  //   imgWidthMobile: '200px',
  //   classes: 'is-6-desktop is-full-mobile',
  //   url: 'https://robime.it/'
  // },
  {
    src: 'imgs/logos/SME_logo.png',
    alt: 'SME',
    imgWidthLarge: '180px',
    imgWidthDesktop: '180px',
    imgWidthTablet: '180px',
    imgWidthMobile: '180px',
    // classes: 'is-6-desktop is-full-mobile',
    classes: 'is-full is-full-mobile',
    url: 'https://www.sme.sk/'
  }
  // {
  //   src: 'imgs/logos/touchit.png',
  //   alt: 'TouchIt',
  //   imgWidthLarge: '200px',
  //   imgWidthDesktop: '200px',
  //   imgWidthTablet: '200px',
  //   imgWidthMobile: '200px',
  //   classes: 'is-6-desktop is-full-mobile logo-margin',
  //   url: 'https://touchit.sk/'
  // },
  // {
  //   src: 'imgs/logos/NEXTECH.jpg',
  //   alt: 'Nextech',
  //   imgWidthLarge: '200px',
  //   imgWidthDesktop: '200px',
  //   imgWidthTablet: '200px',
  //   imgWidthMobile: '200px',
  //   classes: 'is-6-desktop is-full-mobile logo-margin',
  //   url: 'https://www.pcrevue.sk/pc-revue'
  // },
  // {
  //   src: 'imgs/logos/zive.jpg',
  //   alt: 'Zive',
  //   imgWidthLarge: '150px',
  //   imgWidthDesktop: '150px',
  //   imgWidthTablet: '150px',
  //   imgWidthMobile: '150px',
  //   classes: 'is-6-desktop is-full-mobile',
  //   url: 'https://zive.aktuality.sk/'
  // }
];

// const platinumPartner = [
//   {
//     src: 'imgs/logos/redhat.png',
//     alt: 'Red Hat',
//     imgWidthLarge: '300px',
//     imgWidthDesktop: '300px',
//     imgWidthTablet: '300px',
//     imgWidthMobile: '300px',
//     // classes: 'is-4-desktop is-full-mobile logo-margin',
//     classes: 'is-full',
//     url: 'https://www.redhat.com/en'
//   }
// ];
const exhibitionPartners = [
  {
    src: 'imgs/logos/logo_msg_RGB.png',
    alt: 'MSG',
    imgWidthLarge: '155px',
    imgWidthDesktop: '155px',
    imgWidthTablet: '155px',
    imgWidthMobile: '155px',
    // classes: 'is-4-desktop is-full-mobile logo-margin',
    // classes: 'is-6-desktop is-full-mobile',
    classes: 'is-full is-full-mobile',
    url: 'https://bit.ly/msg-life-sk'
  }
  // {
  //   src: 'imgs/logos/TD-SYNNEX.png',
  //   alt: 'TD SYNNEX',
  //   imgWidthLarge: '320px',
  //   imgWidthDesktop: '320px',
  //   imgWidthTablet: '320px',
  //   imgWidthMobile: '320px',
  //   classes: 'is-6-desktop is-full-mobile',
  //   url: 'https://vas.tdsynnex.cz/'
  // }
];
const partnersImgs = [
  {
    src: 'imgs/logos/confluent_logo-denim.png',
    alt: 'Confluent',
    imgWidthLarge: '340px',
    imgWidthDesktop: '340px',
    imgWidthTablet: '340px',
    imgWidthMobile: '340px',
    classes: 'is-6-desktop is-full-mobile',
    url: 'https://www.confluent.io/'
  },
  {
    src: 'imgs/logos/AWS.png',
    alt: 'AWS',
    imgWidthLarge: '140px',
    imgWidthDesktop: '140px',
    imgWidthTablet: '140px',
    imgWidthMobile: '140px',
    classes: 'is-6-desktop is-full-mobile',
    url: 'https://aws.amazon.com/'
  },
  {
    src: 'imgs/logos/swissRe.png',
    alt: 'SwissRe',
    imgWidthLarge: '270px',
    imgWidthDesktop: '270px',
    imgWidthTablet: '270px',
    imgWidthMobile: '270px',
    classes: 'is-6-desktop is-full-mobile',
    // classes: 'is-full is-full-mobile',
    url: 'https://www.swissre.com/'
  },
  {
    src: 'imgs/logos/Siemens_Health.png',
    alt: 'Siemens',
    imgWidthLarge: '250px',
    imgWidthDesktop: '250px',
    imgWidthTablet: '250px',
    imgWidthMobile: '250px',
    classes: 'is-6-desktop is-full-mobile',
    url: 'https://www.siemens-healthineers.com/sk/development-center'
  },
  {
    src: 'imgs/logos/seznam.png',
    alt: 'seznam.cz',
    imgWidthLarge: '280px',
    imgWidthDesktop: '280px',
    imgWidthTablet: '280px',
    imgWidthMobile: '280px',
    classes: 'is-full-mobile',
    url: 'https://o-seznam.cz/kariera/'
  }
  // {
  //   src: 'imgs/logos/MongoDB_ForestGreen.png',
  //   alt: 'MongoDB',
  //   imgWidthLarge: '280px',
  //   imgWidthDesktop: '280px',
  //   imgWidthTablet: '280px',
  //   imgWidthMobile: '280px',
  //   classes: 'is-6-desktop is-full-mobile',
  //   url: 'https://www.mongodb.com/'
  // }
];

const supportersImgs = [
  // {
  //   src: 'imgs/logos/Amazon_Web_Services_Logo.svg',
  //   alt: 'AWS',
  //   imgWidthLarge: '180px',
  //   imgWidthDesktop: '180px',
  //   imgWidthTablet: '180px',
  //   imgWidthMobile: '180px',
  //   classes: 'is-6 is-full-mobile',
  //   url: 'https://aws.amazon.com/'
  // },
  // {
  //   src: 'imgs/logos/swissRe.png',
  //   alt: 'SwissRe',
  //   imgWidthLarge: '270px',
  //   imgWidthDesktop: '270px',
  //   imgWidthTablet: '270px',
  //   imgWidthMobile: '270px',
  //   classes: 'is-6 is-full-mobile',
  //   url: 'https://www.swissre.com/'
  // },
  // {
  //   src: 'imgs/logos/Fragomen.png',
  //   alt: 'Fragomen',
  //   imgWidthLarge: '280px',
  //   imgWidthDesktop: '280px',
  //   imgWidthTablet: '280px',
  //   imgWidthMobile: '280px',
  //   classes: 'is-6 is-full-mobile',
  //   url: 'https://www.fragomen.com'
  // },
  {
    src: 'imgs/logos/tuli.png',
    alt: 'Tuli',
    imgWidthLarge: '130px',
    imgWidthDesktop: '130px',
    imgWidthTablet: '130px',
    imgWidthMobile: '130px',
    // classes: 'is-6 is-full-mobile',
    classes: 'is-full is-full-mobile',
    url: 'https://tuli.sk/'
  }
];

const Sponsors = () => (
  <section className="section" id="sponsors">
    <SponsorPart imgs={organizersImgs} title="ORGANIZERS" />
    {/* <SponsorPart imgs={platinumPartner} title="PLATINUM PARTNER" /> */}
    <SponsorPart imgs={partnersImgs} title="PARTNERS" />
    <SponsorPart imgs={exhibitionPartners} title="EXHIBITION AREA PARTNERS" />
    <SponsorPart imgs={supportersImgs} title="SUPPORTERS" />
    <SponsorPart imgs={mediaPartnersImgs} title="MEDIA PARTNERS" />
  </section>
);

export default Sponsors;
